import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "278.1 153.07 286.83 286.83"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#fff" }, [
      _createElementVNode("path", { d: "M278.1 439.9h286.83V153.07H278.1v286.82Zm110.06-215.12c24.48 0 39.78 30.01 50.94 59.67l-.02-.05c8.73-16.32 20.41-31.35 33.83-31.35 25 0 47.77 54.56 65.78 114.8h-61.43c-22.38.04-35.65-15.76-41.67-32.07-5.92-16.04-24.89-88.39-47.43-88.39-24.54 0-50.25 81.18-55.91 99.32h62.07c19.7 0 28.18-21.67 28.18-21.67l6.32 20.62s-6.32 21.96-34.5 22.18h-91.36c4.04-17.29 37.69-142.1 85.19-143.06Z" }),
      _createElementVNode("path", { d: "M482.1 346.71h28.94s-23.54-72.06-38.12-72.06c-6.48 0-16.72 15.96-25.71 32.75l6.3 17.56c6.6 18.65 15.42 21.75 28.59 21.75Z" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "MonogramWhite"}) } }